import React from "react";

const ProfileScreenContent = ({
  userObj,
  firstNameToggle,
  setfirstNameToggle,
  lastNameToggle,
  setlastNameToggle,
  emailToggle,
  setemailToggle,
  contactNoToggle,
  setcontactNoToggle,
  DOBToggle,
  setDOBToggle,
  handleMediaFileUpload,
  setuserObj,
  handleValidatePhoneNumber,
  handleUpdateProfile,
  setOpenDeleteModal,
  error
}) => {
  const isNameValid = (userObj?.firstName || "").toString().trim() !== "" && (userObj?.lastName || "").toString().trim() !== "";
  return (
    <div className="flex-1 flex justify-center items-start">
      <div className="w-full pb-8 md:pb-10 md:px-10">
        <div className="text-2xl font-bold mb-8 text-gray-900 tracking-tight">My profile</div>
        {/* profile image */}
        <div className="mb-4 flex flex-col items-center">
          <div className="mb-3 text-sm font-semibold text-gray-700 w-full text-left">Profile photo</div>
          <div className="flex items-center gap-6 w-full">
            <span className="inline-block">
              {userObj?.profileDisplayImageUrl ? (
                <img
                  src={`${userObj?.profileDisplayImageUrl}`}
                  alt="profile image"
                  className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover border-2 border-gray-200 shadow-sm bg-gray-100"
                />
              ) : (
                <span className="w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center bg-gray-200 text-gray-500 text-2xl font-bold border-2 border-gray-200 shadow-sm">
                  {userObj?.firstName?.[0] || ""}
                </span>
              )}
            </span>
            <div className="flex flex-col gap-2">
              <label htmlFor="upload-profile-image" className="inline-block bg-[#F6F6FD] border border-gray-300 text-gray-700 px-4 py-2 rounded-lg cursor-pointer text-sm font-medium hover:bg-gray-100 transition">
                Upload photo
              </label>
              <input
                id="upload-profile-image"
                type="file"
                accept="image/*"
                onChange={handleMediaFileUpload}
                className="hidden"
              />
            </div>
          </div>
        </div>
        {/* first name and last name in same row */}
        <div className="mb-3 flex flex-col md:flex-row gap-4">
          {/* First Name */}
          <div className="flex-1">
            <div className="text-xs font-semibold text-gray-600 mb-1">First name</div>
            <div className="flex items-center bg-[#F6F6FD] rounded-lg px-3 py-2 border border-gray-200">
              <input
                value={userObj?.firstName}
                onChange={e => setuserObj({ ...userObj, firstName: e.target.value })}
                className="bg-transparent outline-none w-full text-gray-900 font-medium flex-1"
              />
            </div>
          </div>
          {/* Last Name */}
          <div className="flex-1">
            <div className="text-xs font-semibold text-gray-600 mb-1">Last name</div>
            <div className="flex items-center bg-[#F6F6FD] rounded-lg px-3 py-2 border border-gray-200">
              <input
                value={userObj?.lastName}
                onChange={e => setuserObj({ ...userObj, lastName: e.target.value })}
                className="bg-transparent outline-none w-full text-gray-900 font-medium flex-1"
              />
            </div>
          </div>
        </div>
        {/* email and phone number in same row */}
        <div className="mb-3 flex flex-col md:flex-row gap-4">
          {/* Email address */}
          <div className="flex-1">
            <div className="text-xs font-semibold text-gray-600 mb-1">Email address</div>
            <div className="flex items-center bg-[#F6F6FD] rounded-lg px-3 py-2 border border-gray-200">
              <input
                value={userObj?.secondaryEmail}
                onChange={e => setuserObj({ ...userObj, secondaryEmail: e.target.value })}
                className="bg-transparent outline-none w-full text-gray-900 font-medium flex-1"
              />
            </div>
          </div>
          {/* Phone number */}
          <div className="flex-1">
            <div className="text-xs font-semibold text-gray-600 mb-1">Phone number</div>
            <div className="flex items-center bg-[#F6F6FD] rounded-lg px-3 py-2 border border-gray-200">
              <input
                value={userObj?.phone}
                onChange={e => handleValidatePhoneNumber(e, newNum => setuserObj({ ...userObj, phone: newNum }))}
                className="bg-transparent outline-none w-full text-gray-900 font-medium flex-1"
              />
            </div>
          </div>
        </div>
        {/* Date Of Birth */}
        <div className="mb-4">
          <div className="text-xs font-semibold text-gray-600 mb-1">Date of Birth</div>
          <div className="flex items-center bg-[#F6F6FD] rounded-lg px-3 py-2 border border-gray-200">
            <input
              type="date"
              value={(() => {
                if (!userObj?.birthDate) return "";
                // Extract only the date part and convert to yyyy-mm-dd for input type=date
                const datePart = userObj.birthDate.split(' ')[0];
                const parts = datePart.split('/');
                if (parts.length === 3) {
                  // mm/dd/yyyy to yyyy-mm-dd
                  const [mm, dd, yyyy] = parts;
                  return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
                }
                return datePart;
              })()}
              onChange={e => {
                // Convert yyyy-mm-dd back to mm/dd/yyyy for userObj
                const val = e.target.value;
                if (val) {
                  const [yyyy, mm, dd] = val.split('-');
                  setuserObj({ ...userObj, birthDate: `${mm}/${dd}/${yyyy}` });
                } else {
                  setuserObj({ ...userObj, birthDate: "" });
                }
              }}
              className="bg-transparent outline-none w-full text-gray-900 font-medium flex-1"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-3 md:gap-4 mt-2">
          <button
            className={"flex-1 px-4 py-2.5 rounded-lg font-semibold shadow-sm transition " + (isNameValid ? "bg-[#211F59] hover:bg-[#18164a] text-white" : "bg-[#211F59] text-white opacity-60 cursor-not-allowed")}
            onClick={() => { if (!isNameValid) return; handleUpdateProfile(); }}
            disabled={!isNameValid}
          >
            Change to update
          </button>
          <button className="flex-1 bg-[#F6F6FD] hover:bg-gray-200 text-[#211F59] border border-gray-200 px-4 py-2.5 rounded-lg font-semibold shadow-sm transition" onClick={() => setOpenDeleteModal(true)}>
            Delete Profile
          </button>
        </div>
        <h5 className="text-red-600 mt-3 text-sm font-medium">{error ? error : ""}</h5>
      </div>
    </div>
  );
};

export default ProfileScreenContent;
